/**
 * @generated SignedSource<<6b9915c339e10be6268d9dcc2329b3f2>>
 * @relayHash 90923f2b2adfbd15e2ba3f50b24b8a01
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 90923f2b2adfbd15e2ba3f50b24b8a01

import { ConcreteRequest } from 'relay-runtime';
export type BetterDoc = "ALLOWED" | "CONDITION_PACKAGE" | "NOT_ALLOWED" | "REQUIRED";
export type BetterDocConsultationDetail = "DIAGNOSIS_CODE" | "SPECIALTY";
export type PointOfCareType = "EMERGENCY_CALL" | "EXTERNAL_ASSISTANCE" | "GENERAL_PRACTITIONER" | "HOSPITAL_ELECTIVE" | "HOSPITAL_EMERGENCY_ROOM" | "INCOMPLETE_TELECONSULTATION" | "MEDICAL_EMERGENCY_OR_PERMANENCE" | "SPECIALIST" | "TELECARE";
export type useChBetterDocUsageForConsultationQuery$variables = {
  diagnosisCode?: string | null;
  effectivePointOfCare: PointOfCareType;
  patientId: string;
  specialtyId?: string | null;
};
export type useChBetterDocUsageForConsultationQuery$data = {
  readonly betterDocUsageForConsultation: BetterDoc;
  readonly missingConsultationDetailsThatCanChangeBetterDocUsage: ReadonlyArray<BetterDocConsultationDetail>;
};
export type useChBetterDocUsageForConsultationQuery = {
  response: useChBetterDocUsageForConsultationQuery$data;
  variables: useChBetterDocUsageForConsultationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "diagnosisCode"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "effectivePointOfCare"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "patientId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "specialtyId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "diagnosisCode",
    "variableName": "diagnosisCode"
  },
  {
    "kind": "Variable",
    "name": "effectivePointOfCare",
    "variableName": "effectivePointOfCare"
  },
  {
    "kind": "Variable",
    "name": "patientId",
    "variableName": "patientId"
  },
  {
    "kind": "Variable",
    "name": "specialtyId",
    "variableName": "specialtyId"
  }
],
v5 = [
  {
    "alias": "betterDocUsageForConsultation",
    "args": (v4/*:: as any*/),
    "kind": "ScalarField",
    "name": "ch_betterDocUsageForConsultation",
    "storageKey": null
  },
  {
    "alias": "missingConsultationDetailsThatCanChangeBetterDocUsage",
    "args": (v4/*:: as any*/),
    "kind": "ScalarField",
    "name": "ch_missingConsultationDetailsThatCanChangeBetterDocUsage",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useChBetterDocUsageForConsultationQuery",
    "selections": (v5/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*:: as any*/),
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v3/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "useChBetterDocUsageForConsultationQuery",
    "selections": (v5/*:: as any*/)
  },
  "params": {
    "id": "90923f2b2adfbd15e2ba3f50b24b8a01",
    "metadata": {},
    "name": "useChBetterDocUsageForConsultationQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c6f0b173fbc6cd2ac8eda5cb6957fad9";

export default node;
